"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.eventStreamSerdeProvider = void 0;

var EventStreamMarshaller_1 = require("./EventStreamMarshaller");
/** browser event stream serde utils provider */


exports.eventStreamSerdeProvider = function (options) {
  return new EventStreamMarshaller_1.EventStreamMarshaller(options);
};